import Icon from './components/Icon';

export default Icon;


//////////////////
// WEBPACK FOOTER
// ./~/@ant-design/icons-vue/es/index.js
// module id = 283
// module chunks = 0